<template>
  <div>
    <v-chip
      v-show="invoiceProp && invoiceProp.tax_payer && invoiceProp.tax_payer.status == 'error'"
      color="pink"
      label
      small
      style="margin-left: 1px;margin-right:1px"
      class="px-1 mb-1"
      @click="contentDialog = true"
    >
      <span class="px-1 white--text">
        {{ $t('errorInTaxPayer') }}
      </span>
    </v-chip>
    <v-chip
      v-show="invoiceProp && invoiceProp.tax_payer && invoiceProp.tax_payer.status == 'sent'"
      color="blue"
      label
      small
      style="margin-left: 1px;margin-right:1px"
      class="px-1 mb-1"
      @click="contentDialog = true"
    >
      <span class="px-1 white--text">
        {{ $t('sentToTaxPayer') }}
      </span>
    </v-chip>
    <v-chip
      v-show="invoiceProp && invoiceProp.tax_payer && invoiceProp.tax_payer.status == 'editSent'"
      color="blue"
      label
      small
      style="margin-left: 1px;margin-right:1px"
      class="px-1 mb-1"
      @click="contentDialog = true"
    >
      <span class="px-1 white--text">
        {{ $t('editSent') }}
      </span>
    </v-chip>
    <v-chip
      v-show="invoiceProp && invoiceProp.tax_payer && invoiceProp.tax_payer.status == 'removeSent'"
      color="blue"
      label
      small
      style="margin-left: 1px;margin-right:1px"
      class="px-1 mb-1"
      @click="contentDialog = true"
    >
      <span class="px-1 white--text">
        {{ $t('removeSent') }}
      </span>
    </v-chip>
    <v-chip
      v-show="invoiceProp && invoiceProp.tax_payer && invoiceProp.tax_payer.status == 'sending'"
      color="blue"
      label
      small
      style="margin-left: 1px;margin-right:1px"
      class="px-1 mb-1"
      @click="contentDialog = true"
    >
      <span class="px-1 white--text">
        {{ $t('sending') }}
      </span>
    </v-chip>
    <v-chip
      v-show="invoiceProp && invoiceProp.tax_payer && invoiceProp.tax_payer.status == 'Pending'"
      color="blue"
      label
      small
      style="margin-left: 1px;margin-right:1px"
      class="px-1 mb-1"
      @click="contentDialog = true"
    >
      <span class="px-1 white--text">
        {{ $t('Pending') }}
      </span>
    </v-chip>
    <v-chip
      v-show="invoiceProp && invoiceProp.tax_payer && invoiceProp.tax_payer.status == 'done'"
      color="green"
      label
      small
      style="margin-left: 1px;margin-right:1px"
      class="px-1 mb-1"
      @click="contentDialog = true"
    >
      <span class="px-1 white--text">
        {{ $t('registerInTaxPayer') }}
      </span>
    </v-chip>
    <v-chip
      v-show="invoiceProp && invoiceProp.tax_payer && invoiceProp.tax_payer.state == 'remove'"
      color="red"
      label
      small
      style="margin-left: 1px;margin-right:1px"
      class="px-1 mb-1"
    >
      <span class="px-1 white--text">
        {{ $t('annulment') }}
      </span>
    </v-chip>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="contentDialog"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="contentDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          class="mt-0 pt-0 pr-7"
        >
          <p
            v-if="invoiceProp"
            class="mb-5 text-center"
            style="color: teal"
          >
            {{ $t('invoice') }} {{$t('number')}} {{invoiceProp.number}} - {{invoiceProp.customer.name}}
          </p>
          <p
            v-if="content && content.error && content.error.length == 0"
            class="mb-0"
            style="color: red"
          >
            {{ $t('withoutError') }}
          </p>
          <p
            v-if="content && content.error && content.error.length > 0"
            class="mb-0"
            style="color: red"
          >
            {{ $t('errors') }}
          </p>
          <v-simple-table v-if="content && content.length > 0 && content[0].message">
            <template v-slot:default>
              <thead>
              <tr>
                <th>
                  {{ $t('errorCode') }}
                </th>
                <th>
                  {{ $t('field') }}
                </th>
                <th>
                  {{ $t('content') }}
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                v-for="(item, i) in content"
                :key="i"
              >
                <td>{{ (item.errorCode || '') }}</td>
                <td>{{ (item.field || '') }}</td>
                <td>{{ item.message }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-simple-table v-if="content && content.error && content.error.length > 0">
            <template v-slot:default>
              <thead>
                <tr>
                  <th>
                    {{ $t('errorCode') }}
                  </th>
                  <th>
                    {{ $t('content') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, i) in JSON.parse(content.error)"
                  :key="i"
                >
                  <td>{{ item.code }}</td>
                  <td>{{ item.message }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <p
            v-if="content && content.warning && content.warning.length > 0"
            class="mb-0"
            style="color: dodgerblue"
          >
            {{ $t('warnings') }}
          </p>
          <v-simple-table v-if="content && content.warning && content.warning.length > 0">
            <template v-slot:default>
              <thead>
                <tr>
                  <th>
                    {{ $t('code') }}
                  </th>
                  <th>
                    {{ $t('content') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, i) in content.warning"
                  :key="i"
                >
                  <td>{{ item.code }}</td>
                  <td>{{ item.message }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'TaxPayerContent',
  props: ['invoiceProp'],
  data () {
    return {
      printType: 'unofficial',
      contentDialog: false,
      content: [],
      product: null
    }
  },
  watch: {
    invoiceProp (val) {
      if (this.invoiceProp && val.tax_payer) {
        if (val.tax_payer.state === 'remove' && val.tax_payer.remove_response) {
          this.content.push(JSON.parse(val.tax_payer.remove_response))
        } else if (val.tax_payer.state === 'edit' && val.tax_payer.edit_response) {
          this.content.push(JSON.parse(val.tax_payer.edit_response))
        } else if (val.tax_payer.reponse) {
          this.content.push(JSON.parse(val.tax_payer.reponse))
        }
      } else {
        this.content = []
      }
    }
  },
  mounted () {
    if (this.invoiceProp && this.invoiceProp.tax_payer) {
      if (this.invoiceProp.tax_payer.reponse) {
        this.content = JSON.parse(this.invoiceProp.tax_payer.reponse)
      }
      if (this.invoiceProp.tax_payer.state === 'remove' && this.invoiceProp.tax_payer.remove_response) {
        this.content = JSON.parse(this.invoiceProp.tax_payer.remove_response)
      }
      if (this.invoiceProp.tax_payer.state === 'edit' && this.invoiceProp.tax_payer.edit_response) {
        this.content = JSON.parse(this.invoiceProp.tax_payer.edit_response)
      }
    }
  },
  methods: {
    getProductCard (item) {
      var app = this
      app.loading = true
      app.$axios.get(this.$endpoint + 'products', {
        params: {
          getProductCard: 'active',
          id: item.id
        }
      })
        .then(res => {
          res = res.data
          this.product = res
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => (app.loading = false))
    }
  }
}
</script>

<style scoped>

</style>
